export default {
  hint: 'Potwierdź płatność w banku, aby dokończyć zamówienie.',
  cancel: 'Anuluj płatność',
};
